const BASE_URL = "https://apis.datos.gob.ar/georef/api/"
/**
 * Recordar que las url de Georef no utilizan "/" (forwardslash) al final.
 *
 * Documentacion: https://datosgobar.github.io/georef-ar-api/open-api/#/
 */
module.exports = {
    BASE_URL: BASE_URL,
    provincias: BASE_URL + "provincias",
    localidades: BASE_URL + "localidades",
}



// WEBPACK FOOTER //
// ./src/api/georef/api.js